import BaseResource from './index'

export default class DayTypeResource extends BaseResource {
    static endpoint = '/oasis/restv3/dayTypes'
}
